export default __webpack_public_path__ + "media/images/app-icon-a1f9b4121e7a425485bcc78a343eb0da.svg";